export default "__VITE_ASSET__C_qpB3Cl__"